const Loader = () => {
  return (
    <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-e-transparent border-solid align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white">
      <span className="!absolute -m-px! overflow-hidden! whitespace-nowrap! h-px! w-px! border-0! p-0! [clip:rect(0,0,0,0)]!">
        Loading...
      </span>
    </div>
  );
};
export default Loader;
